<template>
  <v-dialog v-model='showHelp' :max-width='width'>
    <v-card>
      <v-toolbar dense flat :color='color'>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon :color='iconColor' right>{{ icon }}</v-icon>
      </v-toolbar>
      <v-divider class='mb-1'></v-divider>
      <v-card-text>
        <br>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <slot name='dialog-actions'></slot>
        <v-spacer />
        <wc-save-cancel-buttons
          hideCancel
          @save="$emit('closeHelp')"
          saveText='OK'
          :saveColor='saveColor'
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'wc-help-dialog',
  props: {
    showHelp: {
      required: true,
      type: Boolean,
      default: false
    },
    color: {
      required: false,
      default: 'grey lighten-4'
    },
    width: {
      required: false,
      type: String,
      default: '400'
    },
    title: {
      required: false,
      type: String,
      default: 'Help'
    },
    icon: {
      required: false,
      default: 'mdi-help-circle-outline'
    },
    iconColor: {
      required: false,
      default: 'warning'
    },
    saveColor: {
      required: false,
      default: 'warning',
      type: String
    }
  }
}
</script>
